export default __webpack_public_path__ + "static/media/hr.edbf5def.svg";